<template>
  <div class="top-bar main-navbar bg-white border-bottom sticky-top">
    <d-navbar type="light" class="align-items-stretch flex-md-nowrap p-0">
      <a
        href="#"
        class="nav-link nav-link-icon toggle-sidebar text-center border-right" @click="handleToggleSidebar" >
        <i class="material-icons">&#xE5D2;</i>
      </a>
      <figure class="logo-wrapper flex my-0">
        <router-link to="/kokpit" class="my-auto mx-auto" style="display:block; text-align:center;">
            <img
            id="main-logo"
            style="max-width: 110px;"
            src="@/assets/images/headwear.jpg"
            alt="HeadWear CRM">
        </router-link>
      </figure>

      <ul class="navbar-nav border-left flex-row ml-auto">
        <li
          class="nav-item border-right d-flex align-items-center px-2 position-relative"
          style="min-width: 350px;">
          <div class="input-group input-group-seamless w-100 search-v-select-wrapper">
            <div class="input-group-prepend">
              <div class="input-group-text">
                <i class="material-icons">search</i>
              </div>
            </div>

            <v-select
              class="w-100 custom-navbar-search"
              :options="availablePages"
              v-model="selectedPage"
              label="searchTitle"
              :placeholder="$t('ui.goTo')"
              @input="goToPage">
              <template slot="no-options">
                {{ $t('ui.noResults') }}
              </template>

              <template slot="option" slot-scope="option">
                <div class="d-flex align-items-center">
                  {{ option.searchTitle }}
                </div>
              </template>
            </v-select>
          </div>
        </li>

        <li
          v-if="userIsAdminOrWorker"
          class="nav-item border-right">
          <d-link
            class="nav-link nav-link-icon text-center"
            @click.prevent="$bus.$emit('sidebar-products-search-popup-show')"
            title="Wyszukaj produkty">
            <div class="nav-link-icon__wrapper">
              <i class="material-icons">manage_search</i>
            </div>
          </d-link>
        </li>

        <li
          v-if="getItem('/powiadomienia')"
          class="nav-item border-right">
          <d-link
            class="nav-link nav-link-icon text-center"
            :to="getItem('/powiadomienia').to"
            :title="getItem('/powiadomienia').title[currentLanguage]">
            <div class="nav-link-icon__wrapper">
              <div v-if="getItem('/powiadomienia').htmlBefore" v-pure-html="getItem('/powiadomienia').htmlBefore"></div>
            </div>
          </d-link>
        </li>

        <li class="nav-item border-right position-relative">
          <a
            href="#"
            class="nav-link nav-link-icon text-center"
            @click.prevent="$bus.$emit('system-messages-drawer-toggle')"
            title="komunikaty systemowe">
            <div class="nav-link-icon__wrapper">
              <i class="material-icons">notifications</i>
              <d-badge
                v-if="getUnreadSystemMessagesCount > 0"
                pill
                theme="danger"
                class="notification-badge">
                {{ getUnreadSystemMessagesCount }}
              </d-badge>
            </div>
          </a>
        </li>

        <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle text-nowrap px-3" v-d-toggle.user-actions>
            <i class="material-icons mr-2">person</i>
            <span class="d-none d-md-inline-block">{{ getUserEmail }}</span>
          </a>
          <d-collapse id="user-actions" class="dropdown-menu dropdown-menu-small">
            <d-dropdown-item
              v-if="getItem('/moje-konto')"
              :to="getItem('/moje-konto').to"
              class="text-dark">
              <i class="material-icons mr-2 text-primary">verified_user</i>
              {{ getItem('/moje-konto').title[currentLanguage] }}
            </d-dropdown-item>

            <d-dropdown-divider v-if="getItem('/moje-konto')" />

            <d-dropdown-item
              v-if="getItem('/wyloguj')"
              :to="getItem('/wyloguj').to"
              class="text-danger">
              <i class="material-icons mr-2 text-danger">power_settings_new</i>
              {{ getItem('/wyloguj').title[currentLanguage] }}
            </d-dropdown-item>
          </d-collapse>
        </li>
      </ul>
    </d-navbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import getTopbarItems from '@/data/topbar-nav-items';
import getSidebarItems from '@/data/sidebar-nav-items';
import getPrefferedLanguage from '@/utils/i18nUtils.js';

export default {
  name: 'main-topbar',
  data () {
    return {
      availablePages: [],
      selectedPage: null
    };
  },
  computed: {
    ...mapGetters(['getUserEmail', 'getUnreadSystemMessagesCount']),
    userIsAdminOrWorker () {
      return this.$store.getters.getUserType === 'admin' || this.$store.getters.getUserType === 'worker';
    },
    currentLanguage () {
      return getPrefferedLanguage();
    },
    allowedNavItems () {
      const allItems = getTopbarItems();
      return allItems.filter(item => {
        if (item.permission === false || item.permission === undefined) {
          return true;
        }
        return this.$store.getters.getUserPermission(item.permission);
      });
    }
  },
  mounted () {
    this.prepareSearchablePages();
  },
  methods: {
    handleToggleSidebar () {
      this.$bus.$emit('toggle-sidebar');
    },
    getItem (path) {
      return this.allowedNavItems.find(item => item.to === path);
    },
    prepareSearchablePages () {
      const allItems = getSidebarItems();
      const flatList = [];

      const flattenRecursive = (items, parentTitle = '') => {
        items.forEach(item => {
          const hasPermission = item.permission === undefined
            || item.permission === false
            || this.$store.getters.getUserPermission(item.permission);

          if (!hasPermission) {
            return;
          }

          const itemTitle = item.title[this.currentLanguage];
          const fullTitle = parentTitle ? `${parentTitle} > ${itemTitle}` : itemTitle;

          if (item.to && !item.to.startsWith('http')) {
            flatList.push({
              ...item,
              searchTitle: fullTitle
            });
          }

          if (item.items && item.items.length > 0) {
            flattenRecursive(item.items, fullTitle);
          }
        });
      };

      flattenRecursive(allItems);

      const uniquePages = {};
      flatList.forEach(page => {
        if (!uniquePages[page.to] || uniquePages[page.to].searchTitle.length < page.searchTitle.length) {
          uniquePages[page.to] = page;
        }
      });

      this.availablePages = Object.values(uniquePages);
    },
    goToPage (selectedOption) {
      if (selectedOption && selectedOption.to) {
        if (this.$route.path !== selectedOption.to) {
          this.$router.push(selectedOption.to);
        }

        this.$nextTick(() => {
          this.selectedPage = null;
        });
      }
    }
  }
};
</script>

<style scoped>
.notification-badge {
  position: absolute;
  top: 2px;
  right: 5px;
  padding: 0px 5px;
  font-size: 10px;
}
</style>
